<!-- Header Structure -->
<template>
  <footer class="fotter-custom">
    <div class="container py-3 pl-4 text-md-left">
      <div class="row mt-4">
        <div class="col-12 col-md-6 mb-4">
          <ul class="footer-ul">
              <li class="">
                <a href="./#article1" class="link">
                  <p>{{$t("message.article1")}}</p>
                </a>
              </li>
              <li class="">
                <a href="./#article3" class="link">
                  <p>{{$t("message.representative_message")}}</p>
                </a>
              </li>
              <li class="">
                <a href="./#article7" class="link">
                  <p>{{$t("message.aeru_feature")}}</p>
                </a>
              </li>
              <li class="">
                <a href="./#article8" class="link">
                  <p>{{$t("message.aeru_function")}}</p>
                </a>
              </li>
              <li class="">
                <a href="./#fee" class="link">
                  <p>{{$t("message.aeru_fee")}}</p>
                </a>
              </li>
              <li class="mt-5">
                <a href="./privacypolicy" class="link">
                  <p>{{$t("message.privacy_policy")}}</p>
                </a>
              </li>
              <li class="">
                <a href="./termservice" class="link">
                  <p>{{$t("message.terms_service")}}</p>
                </a>
              </li>
              <li class="">
                <a href="./specificcommerce" class="link">
                  <p>{{$t("message.transaction_law")}}</p>
                </a>
              </li>
              <li class="">
                <a href="https://www.aelu.org/" target="_blank" class="link">
                  <p>{{$t("message.about_company")}}</p>
                </a>
              </li>
          </ul>
        </div>
        <div class="col-12 col-md-6 mb-4">
          <ul class="footer-ul">
              <li class="">
                  <p>{{$t("message.update_info")}}</p>
              </li>
              <li class="">
                  <p>{{$t("message.official_sns")}}</p>
              </li>
              <li class="">
                <a href="https://www.instagram.com/aelu_mieruka/" target="_blank" class="link">
                  <p>・{{$t("message.instagram")}}</p>
                </a>
              </li>
              <li class="">
                <a href="https://www.facebook.com/aelu.mieruka" target="_blank" class="link">
                  <p>・{{$t("message.facebook")}}</p>
                </a>
              </li>
          </ul>
        </div>
      </div>
      <p class="text-center">©️2020 MIERUKA inc.</p>
    </div>
  </footer>
</template>

<script>

export default {
    data() {
        return {

        };
    },
    methods: {
    },
    components: {
    },
    async created() {
    },
    watch:{
    }

};
</script>
<style scoped lang="scss"> 
.link{
  color: #FFFFFF
}
.fotter-custom{
    background-color: #000054;
    color: #FFFFFF;
    bottom: 0;
}
.footer-ul {
  list-style: none;
}
@media (max-width: 576px) {
   .footer-ul {
      padding-inline-start: 0px;
    }
}
</style>
